import { useEffect, useState } from 'react';
import StatusBadge from './StatusBadge';
import api from '../lib/api';

export function StatusTimeline({ docType, docId, fallbackDates = [] }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!docId) return;
    let alive = true;
    api.get(`/history/${docType}/${docId}`)
      .then((r) => { if (alive) setRows(r.data || []); })
      .catch(() => { if (alive) setRows([]); });
    return () => { alive = false; };
  }, [docType, docId]);

  if (rows === null) return <p className="text-xs text-slate-400">Memuat riwayat...</p>;

  const legacy = fallbackDates.filter((f) => f.at);

  return (
    <div className="border rounded-lg p-3" data-testid="status-timeline">
      <p className="text-sm font-semibold mb-2">Riwayat Status</p>
      {rows.length === 0 && legacy.length === 0 && (
        <p className="text-xs text-slate-500" data-testid="status-timeline-empty">Belum ada riwayat tercatat (dokumen dibuat sebelum fitur ini aktif).</p>
      )}
      <ol className="relative border-l border-slate-200 ml-2 space-y-3">
        {rows.length === 0 && legacy.map((f, i) => (
          <li key={`l${i}`} className="ml-4 text-xs" data-testid={`timeline-legacy-${i}`}>
            <span className="absolute -left-1.5 mt-1 h-3 w-3 rounded-full bg-slate-300" />
            <p className="text-slate-700">{f.label}</p>
            <p className="text-slate-400">{new Date(f.at).toLocaleString('id-ID')}{f.by ? ` · ${f.by}` : ''}</p>
          </li>
        ))}
        {rows.map((r, i) => (
          <li key={r.id || i} className="ml-4 text-xs" data-testid={`timeline-row-${i}`}>
            <span className="absolute -left-1.5 mt-1 h-3 w-3 rounded-full bg-amber-400" />
            <div className="flex items-center gap-1 flex-wrap">
              {r.from_status ? <StatusBadge status={r.from_status} /> : <span className="text-slate-400">—</span>}
              <span className="text-slate-400">→</span>
              <StatusBadge status={r.to_status} />
            </div>
            {r.reason && <p className="text-slate-700 mt-0.5">{r.reason}</p>}
            <p className="text-slate-400">{new Date(r.at).toLocaleString('id-ID')} · {r.actor_name}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
